const cellColor: Record<string, string> = {
  Y: "bg-green-100 text-green-800",
  A: "bg-blue-100 text-blue-800",
  N: "bg-red-100 text-red-700",
  "N/A": "bg-gray-100 text-gray-500",
};

export function Badge({ value }: { value: string }) {
  return (
    <span className={`inline-block px-2 py-0.5 rounded text-xs font-semibold ${cellColor[value] ?? "text-gray-400"}`}>
      {value}
    </span>
  );
}

export function Link({ href }: { href: string | null }) {
  if (!href) return <span className="text-gray-300">—</span>;
  const url = new URL(href);
  return <a href={href} target="_blank" rel="noreferrer" className="text-blue-600 hover:underline text-xs">{url.hostname}</a>;
}
